import { useMemo, useState } from "react";
import type { RefObject } from "react";
import DatePicker, {
  utils,
} from "@hassanmojab/react-modern-calendar-datepicker";
import type { DayRange } from "@hassanmojab/react-modern-calendar-datepicker";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import { ArrowDown2, Calendar as CalendarIcon } from "iconsax-reactjs";
import { formatChainDateRange } from "./wizardUtils";
import type { ChainDateRange } from "./wizardTypes";

type Props = {
  value: ChainDateRange | null;
  onChange: (value: ChainDateRange | null) => void;
  disabled?: boolean;
};

const toDayRange = (value: ChainDateRange | null): DayRange =>
  value ? { from: value.from, to: value.to } : { from: null, to: null };

export default function DateRangeField({ value, onChange, disabled }: Props) {
  const [draftRange, setDraftRange] = useState<DayRange>(() =>
    toDayRange(value),
  );

  const today = useMemo(() => utils("fa").getToday(), []);

  const handleChange = (range: DayRange) => {
    setDraftRange(range);

    if (range.from && range.to) {
      onChange({ from: range.from, to: range.to });
    } else if (!range.from && !range.to) {
      onChange(null);
    }
  };

  const label = formatChainDateRange(value);

  return (
    <DatePicker
      value={draftRange}
      onChange={handleChange}
      locale="fa"
      minimumDate={today}
      calendarPopperPosition="bottom"
      wrapperClassName="w-full max-w-[300px]"
      renderInput={({ ref }) => (
        <button
          type="button"
          ref={ref as RefObject<HTMLButtonElement>}
          disabled={disabled}
          className="flex h-12 w-full items-center gap-2 rounded-lg border border-gray-300 px-4 text-base transition-colors focus:border-primaryVar-500 disabled:bg-gray-100"
        >
          <CalendarIcon size={18} className="shrink-0 text-gray-400" />

          <span
            className={`flex-1 truncate text-right ${label ? "text-gray-800" : "text-gray-400"}`}
          >
            {label || "تاریخ"}
          </span>
          <ArrowDown2 size={18} className="shrink-0 text-gray-400" />
        </button>
      )}
    />
  );
}
